// @ts-nocheck
const roleInformationInitialValues = {
  // rolesWorked: '',
  roleExperience: [],
  preferredPiecesOfGear: '',
  // certificatesAccreditations: ''
};

export {
  roleInformationInitialValues
};